<nz-layout class="app-layout">
	<nz-content *ngIf="isLogin">
		<div class="inner-content">
			<router-outlet></router-outlet>
		</div>
	</nz-content>
</nz-layout>